import { interactable_bianca_objects } from './bianca_data'
import { interactable_mailman_cat_objects } from './mailman_cat_data'
import { interactable_mushroom_room_objects } from './mushroom_house_data'
import { interactable_world_objects } from './world_data'
import { InteractableObject } from '../types/portfolio_types'

const interactable_objects: { [key: string]: InteractableObject } = {
  ...interactable_bianca_objects,
  ...interactable_mailman_cat_objects,
  ...interactable_mushroom_room_objects,
  ...interactable_world_objects,
}

export { interactable_objects }
